<template>
  <div id="HomePage">
    <BannerSection></BannerSection>

    <!-- 旋转 -->
    <div class="service-section pt-80 pb-80">
      <img
        src="@/assets/images/bg/water-mark1.png"
        alt="image"
        class="img-fluid water-mark1"
      />
      <img
        src="@/assets/images/bg/water-mark2.png"
        alt="image"
        class="img-fluid water-mark2"
      />
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-md-8">
            <div class="section-title primary4">
              <span>自主软件产品</span>
              <h3>我们的产品</h3>
              <p class="para">
                公司紧扣新质生产力发展脉搏，深耕医疗健康、电子政务与数字企业三大领域，围绕诊疗服务、政务办理、企业经营三类核心场景打造多款款自主软件产品，为行业客户提供覆盖全业务链条的数字化能力
              </p>
            </div>
          </div>
        </div>
        <div class="row position-relative justify-content-center">
          <div class="swiper service-slider1 swiper-fix">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <div
                  class="service-item1 wow fadeInDown"
                  data-wow-duration="1.5s"
                  data-wow-delay="0.2s"
                >
                  <div class="service-img">
                    <a href="service-details.html" class="service-details-btn"
                      ><img src="@/assets/images/icons/arrow.svg" alt="image"
                    /></a>
                    <img alt="image" src="@/assets/images/bg/service11.png" />
                    <div class="overlay"></div>
                  </div>
                  <div class="service-content">
                    <div class="service-icon">
                      <img src="@/assets/images/icons/webdev.svg" alt="image" />
                    </div>
                    <h4>
                      <a href="service-details.html">医疗健康</a>
                    </h4>
                    <p class="para">
                       把就医、诊疗、院后服务、资产管理等各个环节数字化，助力医院持续提升服务与运营效率
                    </p>
                  </div>
                </div>
              </div>
              <div class="swiper-slide">
                <div
                  class="service-item1 wow fadeInDown"
                  data-wow-duration="1.5s"
                  data-wow-delay="0.4s"
                >
                  <div class="service-img">
                    <a href="service-details.html" class="service-details-btn"
                      ><img src="@/assets/images/icons/arrow.svg" alt="image"
                    /></a>
                    <img alt="image" src="@/assets/images/bg/service12.png" />
                    <div class="overlay"></div>
                  </div>
                  <div class="service-content">
                    <div class="service-icon">
                      <img src="@/assets/images/icons/brandsolution.svg" alt="image" />
                    </div>
                    <h4>
                      <a href="service-details.html">电子政务</a>
                    </h4>
                    <p class="para">
                     为政务部门履行公共服务、社会管理和宏观调控提供支撑，助力跨部门数据共享与业务协同
                    </p>
                  </div>
                </div>
              </div>
              <div class="swiper-slide">
                <div
                  class="service-item1 wow fadeInDown"
                  data-wow-duration="1.5s"
                  data-wow-delay="0.6s"
                >
                  <div class="service-img">
                    <a href="service-details.html" class="service-details-btn"
                      ><img src="@/assets/images/icons/arrow.svg" alt="image"
                    /></a>
                    <img alt="image" src="@/assets/images/bg/service13.png" />
                    <div class="overlay"></div>
                  </div>
                  <div class="service-content">
                    <div class="service-icon">
                      <img src="@/assets/images/icons/uiux.svg" alt="image" />
                    </div>
                    <h4>
                      <a href="service-details.html">数字企业</a>
                    </h4>
                    <p class="para">
                       围绕企业经营全流程定制软件开发和运营数据分析，把分散数据持续沉淀为可复用经营资产
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="slider-arrows text-center d-xl-flex d-none justify-content-between">
            <div
              class="service-prev1 swiper-prev-arrow"
              tabindex="0"
              role="button"
              aria-label="Previous slide"
            >
              <svg
                width="46"
                height="46"
                viewBox="0 0 46 46"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="23" cy="23" r="22.25" stroke-width="1.5" />
                <path
                  d="M20 27.573V23V18.427C20 18.2574 19.8022 18.1648 19.672 18.2734L14 23L19.672 27.7266C19.8022 27.8352 20 27.7426 20 27.573Z"
                />
                <path
                  d="M32 23.5C32.2761 23.5 32.5 23.2761 32.5 23C32.5 22.7239 32.2761 22.5 32 22.5V23.5ZM19.672 27.7266L19.9921 27.3425V27.3425L19.672 27.7266ZM14 23L13.6799 22.6159L13.219 23L13.6799 23.3841L14 23ZM19.672 18.2734L19.3519 17.8893L19.3519 17.8893L19.672 18.2734ZM32 22.5H20V23.5H32V22.5ZM19.5 23V27.573H20.5V23H19.5ZM19.9921 27.3425L14.3201 22.6159L13.6799 23.3841L19.3519 28.1107L19.9921 27.3425ZM14.3201 23.3841L19.9921 18.6575L19.3519 17.8893L13.6799 22.6159L14.3201 23.3841ZM19.5 18.427V23H20.5V18.427H19.5ZM19.9921 18.6575C19.7967 18.8203 19.5 18.6814 19.5 18.427H20.5C20.5 17.8335 19.8078 17.5093 19.3519 17.8893L19.9921 18.6575ZM19.5 27.573C19.5 27.3186 19.7967 27.1797 19.9921 27.3425L19.3519 28.1107C19.8078 28.4907 20.5 28.1665 20.5 27.573H19.5Z"
                />
              </svg>
            </div>
            <div
              class="service-next1 swiper-next-arrow"
              tabindex="0"
              role="button"
              aria-label="Next slide"
            >
              <svg
                width="46"
                height="46"
                viewBox="0 0 46 46"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="23" cy="23" r="23" />
                <path
                  d="M26 18.427V23V27.573C26 27.7426 26.1978 27.8352 26.328 27.7266L32 23L26.328 18.2734C26.1978 18.1648 26 18.2574 26 18.427Z"
                />
                <path
                  d="M14 22.5C13.7239 22.5 13.5 22.7239 13.5 23C13.5 23.2761 13.7239 23.5 14 23.5V22.5ZM26.328 18.2734L26.0079 18.6575V18.6575L26.328 18.2734ZM32 23L32.3201 23.3841L32.781 23L32.3201 22.6159L32 23ZM26.328 27.7266L26.6481 28.1107L26.6481 28.1107L26.328 27.7266ZM14 23.5H26V22.5H14V23.5ZM26.5 23V18.427H25.5V23H26.5ZM26.0079 18.6575L31.6799 23.3841L32.3201 22.6159L26.6481 17.8893L26.0079 18.6575ZM31.6799 22.6159L26.0079 27.3425L26.6481 28.1107L32.3201 23.3841L31.6799 22.6159ZM26.5 27.573V23H25.5V27.573H26.5ZM26.0079 27.3425C26.2033 27.1797 26.5 27.3186 26.5 27.573H25.5C25.5 28.1665 26.1922 28.4907 26.6481 28.1107L26.0079 27.3425ZM26.5 18.427C26.5 18.6814 26.2033 18.8203 26.0079 18.6575L26.6481 17.8893C26.1922 17.5093 25.5 17.8335 25.5 18.427H26.5Z"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 您身边的IT专家 -->
    <!-- <div class="about1-section pt-120 pb-120"> -->
    <div class="about1-section pt-80 pb-80">
      <img
        src="@/assets/images/bg/section-bg1.png"
        class="img-fluid section-bg1"
        alt="image"
      />
      <div class="container">
        <div class="row g-4 align-items-center">
          <!-- 左侧 文字内容 -->
          <div class="col-lg-6 order-lg-1 order-2">
            <div
              class="about1-content wow fadeInLeft"
              data-wow-duration="1.5s"
              data-wow-delay="0.2s"
            >
              <span>行业解决方案</span>
              <h3><em>行业数字化</em>综合解决方案</h3>
              <p class="para">
                我们深耕行业数字化主航道，面向医疗健康、电子政务、数字企业，提供从顶层规划到落地运营的一站式综合解决方案，以数字化能力服务行业客户高质量发展。
              </p>
              <ul class="feature-list">
                <li>
                  <span class="feature-num">01</span>
                  <span class="feature-text">以模块化产品架构为基石，将能力拆为可组合的产品模块。</span>
                </li>
                <li>
                  <span class="feature-num">02</span>
                  <span class="feature-text">以统一数据中台实现跨系统数据归集共享，让沉淀数据转为可用资产</span>
                </li>
                <li>
                  <span class="feature-num">03</span>
                  <span class="feature-text">以 AI+ 应用开发承接智能问答、辅助审核、数据分析等真实场景。</span>
                </li>
              </ul>
              <p class="para">
                得益于贯通的数据与流程，三大板块得以复用经验、协同发力。我们坚持先回应客户最紧迫诉求，系统稳定后循序渐进叠加能力。长远看，我们与客户一道理顺分散的信息化系统，让数据顺畅流转、业务线上闭环，陪伴客户从系统上线为标志的信息化，迈向数据驱动的数字化，再到具备自主判断能力的智能化。
              </p>
              <router-link to="/Solution/Solution1" class="eg-btn btn--primary btn--lg"
                >查看行业解决方案</router-link
              >
            </div>
          </div>
          <!-- 右侧 图片（始终右侧） -->
          <div
            class="col-lg-6 order-lg-2 order-1 d-flex justify-content-center align-items-center"
          >
            <div class="about-images">
              <img
                class="img-fluid"
                src="@/assets/images/20250724/gywm.jpg"
                alt="关于华德"
              />
            </div>
          </div>
        </div>
        <!-- 行业数字化 板块开始 -->
        <section id="section_hangye" style="background-color: #fafafc; padding: 30px 0px">
          <div class="container" id="solutions_hangye">
            <div class="mu-title" style="margin-bottom: 50px">
              <h2 class="section-title text-center">
                <span class="text-theme font-size-37" style="color: rgb(204, 12, 29)"
                  >INDUSTRY DIGITIZATION</span
                ><br />
                <span class="text-theme font-size-40" style="color: rgb(204, 12, 29)"
                  >行业数字化</span
                >
              </h2>
            </div>
            <div
              class="d-flex justify-content-center align-items-stretch flex-wrap"
              style="gap: 24px"
            >
              <!-- 卡片1 -->
              <div
                class="team-member div_solution industry-card"
                style="flex: 0 0 280px; max-width: 280px"
              >
                <a>
                  <div class="image">
                    <img
                      class="solution-img"
                      src="@/assets/images/20250724/shuzihua/1.jpg"
                      alt="医疗健康"
                    />
                  </div>
                  <div class="team-member-box">
                    <div class="solutions_hangye_title">
                      <span>医疗健康</span>
                      <span class="solutions_hangye_title_en">Healthcare</span>
                    </div>
                    <p class="ind-summary">围绕诊疗与健康管理，打通三医数据，支撑智慧就医、互联网医院与临床辅助应用落地。</p>
                  </div>
                </a>
              </div>
              <!-- 卡片2 -->
              <div
                class="team-member div_solution industry-card"
                style="flex: 0 0 280px; max-width: 280px"
              >
                <a>
                  <div class="image">
                    <img
                      class="solution-img"
                      src="@/assets/images/20250724/shuzihua/public-health.jpg"
                      alt="公共卫生"
                    />
                  </div>
                  <div class="team-member-box">
                    <div class="solutions_hangye_title">
                      <span>公共卫生</span>
                      <span class="solutions_hangye_title_en">Public Health</span>
                    </div>
                    <p class="ind-summary">围绕监测预警与应急调度，贯通疾控与救治链条，支撑突发公卫事件早发现、早处置。</p>
                  </div>
                </a>
              </div>
              <!-- 卡片3 -->
              <div
                class="team-member div_solution industry-card"
                style="flex: 0 0 280px; max-width: 280px"
              >
                <a>
                  <div class="image">
                    <img
                      class="solution-img"
                      src="@/assets/images/20250724/shuzihua/3.jpg"
                      alt="电子政务"
                    />
                  </div>
                  <div class="team-member-box">
                    <div class="solutions_hangye_title">
                      <span>电子政务</span>
                      <span class="solutions_hangye_title_en">E-Government</span>
                    </div>
                    <p class="ind-summary">围绕一网通办与一网统管，整合人口、证照与应急数据，提升跨部门办事与治理效率。</p>
                  </div>
                </a>
              </div>
              <!-- 卡片4 -->
              <div
                class="team-member div_solution industry-card"
                style="flex: 0 0 280px; max-width: 280px"
              >
                <a>
                  <div class="image">
                    <img
                      class="solution-img"
                      src="@/assets/images/20250724/shuzihua/4.jpg"
                      alt="大型企业"
                    />
                  </div>
                  <div class="team-member-box">
                    <div class="solutions_hangye_title">
                      <span>数字企业</span>
                      <span class="solutions_hangye_title_en">Enterprise</span>
                    </div>
                    <p class="ind-summary">围绕开发管控与运营分析，贯通经营全流程数据，帮企业把沉淀数据转化为经营决策力。</p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>

    <!-- 公司优势区块 -->
    <!-- <div id="contactUs" class="container-fuild">

   </div> -->

    <!-- 公司优势 -->
    <div id="Service" class="container-fuild">
      <div class="container Service-container">
        <p class="Service-title text-center text-white">公司优势</p>
        <p class="Service-title2 text-center">为客户解决问题，为客户创造新的价值</p>
        <div class="flex">
          <!-- <img src="@/assets/images/ruanzhu.png" style="width: 100%" alt="" /> -->
          <div class="advantage-card-container">
            <div class="advantage-card" v-for="item in serviceList" :key="item.id">
              <div class="card" @click="ServiceClick(item.id)">
                <img :src="item.img" alt="示例图片" class="card-img" />
              </div>
              <div class="card-content">
                <p class="card-text">{{ item.title }}</p>
                <p class="card-desc">{{ item.eng_title }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 新闻中心 -->
    <div id="whyChooseUs" class="container-fuild">
      <div class="container">
        <div class="whyChooseUs-title text-center" style="margin-bottom: 50px">
          <p class="customer-title text-center">荣誉资质</p>
        </div>
        <div class="row">
          <!-- 新闻1 -->
          <div class="col-md-4 col-sm-6 col-xs-12">
            <div class="default-blog-news">
              <div class="img-box">
                <a
                  href="newsDetail.html?id=c8434c8e-7199-419e-70b3-08dc38f50be1"
                  target="_blank"
                >
                  <!-- 证书位图 -> HTML 复刻（与 newsinformation 页同一规范） -->
                  <CertReplica cert="gaoxin" />
                </a>
              </div>
              <div class="lower-content" style="padding-top: 10px">
                <h4 class="post-meta text-center">国家级高新技术企业</h4>
              </div>
            </div>
          </div>
          <!-- 新闻2 -->
          <div class="col-md-4 col-sm-6 col-xs-12">
            <div class="default-blog-news">
              <div class="img-box">
                <a
                  href="newsDetail.html?id=c8434c8e-7199-419e-70b3-08dc38f50be1"
                  target="_blank"
                >
                  <!-- 证书位图 -> HTML 复刻（与 newsinformation 页同一规范） -->
                  <CertReplica cert="keji" />
                </a>
              </div>
              <div class="lower-content" style="padding-top: 10px">
                <h4 class="post-meta text-center">国家科技型中小企业</h4>
              </div>
            </div>
          </div>
          <!-- 新闻3 -->
          <div class="col-md-4 col-sm-6 col-xs-12">
            <div class="default-blog-news">
              <div class="img-box">
                <a
                  href="newsDetail.html?id=c8434c8e-7199-419e-70b3-08dc38f50be1"
                  target="_blank"
                >
                  <!-- 证书位图 -> HTML 复刻（与 newsinformation 页同一规范） -->
                  <CertReplica cert="chuangxin" />
                </a>
              </div>
              <div class="lower-content" style="padding-top: 10px">
                <h4 class="post-meta text-center">海南省创新型中小企业</h4>
              </div>
            </div>
          </div>
          <!-- 第4张：海南省高新技术种子企业（CertReplica 已支持 zhongzi） -->
          <div class="col-md-4 col-sm-6 col-xs-12">
            <div class="default-blog-news">
              <div class="img-box">
                <a
                  href="newsDetail.html?id=c8434c8e-7199-419e-70b3-08dc38f50be1"
                  target="_blank"
                >
                  <!-- 证书位图 -> HTML 复刻（与 newsinformation 页同一规范） -->
                  <CertReplica cert="zhongzi" />
                </a>
              </div>
              <div class="lower-content" style="padding-top: 10px">
                <h4 class="post-meta text-center">海南省高新技术种子企业</h4>
              </div>
            </div>
          </div>
          <!-- 合规免责：证书为版式示意
          <div class="col-12">
            <p class="cert-disclaimer" style="margin-top: 12px">
              说明：页面展示为证书样式示意，非扫描件；资质信息以主管部门公示及证书原件为准。
            </p>
          </div>
           -->
          <!-- 更多荣誉按钮 -->
          <div class="col-12 text-center" style="margin-top: 20px">
            <router-link to="/newsinformation" class="btn btn-theme" target="_blank">
              更多荣誉 <i class="fa fa-fw fa-angle-double-right"></i>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <!-- 合作伙伴 -->
    <div id="whyChooseUs" class="conatiner-fuild" style="background: #efefef">
      <div class="container">
        <div class="whyChooseUs-title text-center">
          <p>合作客户</p>
        <p class="para" style="max-width:760px;margin:0 auto 30px;text-align:center;">我们的客户与生态伙伴覆盖医疗、通信、政务、金融与文旅等行业，在各类信息化项目中协同共建。</p>
          <!-- <p>THE REASON TO CHOOSING US</p> -->
        </div>
        <div class="wow fadeInUp" data-wow-duration="1.5s" data-wow-delay="0.2s">
          <PartnerMarquee :list="partnerList" />
        </div>
        <p class="partner-note">以上客户排序不分先后。</p>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
import { WOW } from "wowjs";
import BannerSection from "./components/BannerSection.vue";
import CertReplica from "@/components/CertReplica.vue";
import PartnerMarquee from "@/components/PartnerMarquee.vue";
import partnerList from "@/assets/data/partners.js";
export default {
  name: "HomePage2",
  components: {
    CertReplica,
    PartnerMarquee,
    BannerSection,
  },
  data() {
    return {
      selectedIndex: -1, // 初始未选中状态
      // 合作伙伴数据（来源 @/assets/data/partners.js，可只填名称、logo 留空）
      partnerList,
      serviceList: [
        {
          id: "section-1",
          title: "服务能力",
          eng_title: "需求快速响应、问题定点解决，支持按客户实际场景灵活调整实施方案与节奏。",
          img: require("@/assets/images/pic21.png"),
        },
        {
          id: "section-2",
          title: "业务咨询",
          eng_title: "熟悉医疗与政务系统全流程，行业顾问参与需求梳理、方案设计与落地陪跑。",
          img: require("@/assets/images/pic22.png"),
        },
        {
          id: "section-3",
          title: "技术架构",
          eng_title: "微服务架构，配套统一数据中台与智能分析能力，便于横向扩展与系统对接。",
          img: require("@/assets/images/pic23.png"),
        },
        {
          id: "section-4",
          title: "交付保障",
          eng_title: "分阶段确认、迭代交付，关键节点评审留痕，需求变更全程可追溯。",
          img: require("@/assets/images/pic24.png"),
        },
      ],
      swiperList: [
        {
          img: require("@/assets/img/banner_1.jpg"),
          path: "/companyintroduction",
          title: "海南华德科技有限公司",
          content: "提供更全面的医疗健康和电子政务行业综合解决方案",
        },
        {
          img: require("@/assets/img/banner2.jpg"),
          path: "/software/software1",
          title: "智慧医工 让数据说话",
          content: "芯医工-医疗数据全生命周期管理系统",
        },
        {
          img: require("@/assets/img/banner3.png"),
          path: "/software/software4",
          title: "智慧病房",
          content:
            "以医护患为中心，以医疗护理为主线，打造医护患物数一体化的现代信息化智慧病房",
        },
        {
          img: require("@/assets/img/banner11.jpeg"),
          path: "/software/software2",
          title: "一站式互联网医院便民系统",
          content: "打造一站式便民服务和医院信息化建设新典范",
        },
      ],
      customerList: [
        {
          logo: require("@/assets/img/101.jpg"),
        },
        {
          logo: require("@/assets/img/102.jpg"),
        },
        {
          logo: require("@/assets/img/103.jpg"),
        },
        {
          logo: require("@/assets/img/104.jpg"),
        },
        {
          logo: require("@/assets/img/105.jpg"),
        },
        {
          logo: require("@/assets/img/106.jpg"),
        },
        {
          logo: require("@/assets/img/107.jpg"),
        },
        {
          logo: require("@/assets/img/108.jpg"),
        },
        {
          logo: require("@/assets/img/109.jpg"),
        },
        {
          logo: require("@/assets/img/110.jpg"),
        },
        {
          logo: require("@/assets/img/111.jpg"),
        },
        {
          logo: require("@/assets/img/112.jpg"),
        },
        {
          logo: require("@/assets/img/113.jpg"),
        },
        {
          logo: require("@/assets/img/114.jpg"),
        },
        {
          logo: require("@/assets/img/115.jpg"),
        },
        {
          logo: require("@/assets/img/116.jpg"),
        },
      ],
      serverList: [
        {
          logo: require("@/assets/img/tel.png"),
          title: "核心优势1",
          content: "<p>由专业客服提供人工服务</p>负责疑难问题和故障受理",
        },
        {
          logo: require("@/assets/img/computer.png"),
          title: "核心优势2",
          content: "<p>利用远程视频工具，提供协助</p>帮助客户进行调试、解决故障",
        },
        {
          logo: require("@/assets/img/qq.png"),
          title: "核心优势3",
          content: "<p>利用企业QQ提供在线解答</p>帮助企业快速准确解决问题和故障",
        },
        {
          logo: require("@/assets/img/skill.png"),
          title: "核心优势4",
          content: "<p>由技术支持工程师，负责问题解答</p>需求受理及故障受理",
        },
      ],
    };
  },
  mounted() {
    let mySwiper = new Swiper(".service-slider1", {
      slidesPerView: 3,
      speed: 1200,
      spaceBetween: 15,
      autoplay: true,
      loop: true,
      roundLengths: true,
      pagination: { el: ".swiper-pagination", clickable: "true" },
      navigation: { nextEl: ".service-prev1", prevEl: ".service-next1" },
      breakpoints: {
        280: { slidesPerView: 1, navigation: false },
        480: { slidesPerView: 1, navigation: false },
        768: { slidesPerView: 2, navigation: false },
        992: { slidesPerView: 2 },
        1200: { slidesPerView: 3 },
      },
    });

    // 初始化 Sponsor Slider
    new Swiper(".sponsor-slider", {
      slidesPerView: 5, // 默认显示5个
      spaceBetween: 30, // 幻灯片之间的间距
      loop: true, // 循环模式
      autoplay: {
        delay: 2500, // 自动播放间隔2.5秒
        disableOnInteraction: false, // 用户操作后继续自动播放
      },
      navigation: {
        nextEl: ".sponsor-next1", // 下一页按钮
        prevEl: ".sponsor-prev1", // 上一页按钮
      },
      breakpoints: {
        // 响应式断点
        320: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
        1200: {
          slidesPerView: 5,
          spaceBetween: 50,
        },
      },
    });
  },
  props: {
    item: { type: Object, required: true },
    isActive: { type: Boolean, default: false },
  },
  methods: {
    onClick() {
      this.$emit("select");
    },
    ServiceClick(index) {
      // 找到点击项的索引
      //const index = this.serviceList.findIndex(item => item.id === id);
      //this.selectedIndex = index;
      console.log("点击的服务项索引:", index);
      if (index === 1) {
        // 如果找到，跳转到对应的页面
        this.$router.push({ path: "/Solution/Solution1" });
      } else if (index === 2) {
        this.$router.push({ path: "/Solution/Solution6" });
      } else if (index === 3) {
        this.$router.push({ path: "/Solution/Solution8" });
      } else if (index === 4) {
        this.$router.push({ path: "/Solution/Solution10" });
      } else {
        console.error("未找到对应的服务项");
      }
    },
    toPageEv() {
      this.$router.push({
        path: "/companyintroduction",
      });
    },
    toUrl(path) {
      if (path) {
        this.$router.push({
          path,
        });
      } else {
        return;
      }
    },
    toDetail() {
      this.$router.push({
        path: "/software/software1",
      });
    },
  },
};
</script>
<style scoped>
@import url("../assets/css/bootstrap.min.css");
@import url("../assets/css/boxicons.min.css");
@import url("../assets/css/swiper-bundle.css");
@import url("../assets/css/style.css");
.cursor {
  cursor: pointer;
}

/* 行业数字化能力三列并列 */
.about1-content .feature-list {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin: 24px 0;
  padding: 0;
  list-style: none;
}

.about1-content .feature-list li {
  flex: 1 1 calc(33.333% - 14px);
  min-width: 220px;
  background: #fff;
  border-radius: 16px;
  padding: 28px 22px;
  box-shadow: 0 4px 20px rgba(29, 43, 72, 0.08);
  border: 1px solid #e6e8ed;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  position: relative;
  overflow: hidden;
}

.about1-content .feature-list li::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: #e6004c;
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.4s ease;
}

.about1-content .feature-list li:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 32px rgba(29, 43, 72, 0.14);
  border-color: #e6004c;
}

.about1-content .feature-list li:hover::before {
  transform: scaleX(1);
}

.about1-content .feature-list .feature-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: rgba(230, 0, 76, 0.1);
  color: #e6004c;
  font-size: 15px;
  font-weight: 700;
  border-radius: 10px;
  margin-bottom: 16px;
}

.about1-content .feature-list .feature-text {
  display: block;
  font-size: 15px;
  line-height: 1.75;
  color: #676767;
}

@media (max-width: 991px) {
  .about1-content .feature-list li {
    flex: 1 1 100%;
  }
}

/* 合规免责：证书为版式示意 */
.cert-disclaimer {
  text-align: center;
  font-size: 12px;
  color: #676767;
  margin: 8px 0 0;
}
.flex {
  display: flex;
  justify-content: center;
}
/* 整体盒子 */
#HomePage {
  width: 100%;
}

/* 轮播图 */
/* #swiper {
  height: 600px;
}
#swiper .banner-swiper {
  width: 100%;
  height: 100%;
}
#swiper .banner-swiper .swiper-slide img {
  width: 100%;
  height: 100%;
}
#swiper .banner-swiper .swiper-slide {
  position: relative;
}
#swiper .banner-swiper .swiper-slide-title {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999999999;
  width: 100%;
  height: 100%;
  color: #fff;
  background: rgba(51, 51, 51, 0.534);
  text-align: center;
  line-height: 80px;
}
#swiper .banner-swiper .swiper-slide-title > h1 {
  font-size: 50px;
  margin-top: 12%;
}
#swiper .banner-swiper .swiper-slide-title > p {
  font-size: 20px;
  margin-top: 1%;
  font-weight: 700;
} */
/* 大数据管理系统 */
#bigData {
  padding: 100px;
  transition: all ease 0.6s;
  box-sizing: border-box;
}
#bigData .bigData-title {
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
}
#bigData p {
  font-size: 14px;
  color: #333;
  line-height: 2rem;
}
#bigData img {
  width: 100%;
}
#bigData .bigData-device {
  margin: 50px 0 20px;
  font-size: 14px;
}

/* 您身边的IT专家 */
#contactUs {
  color: #fff;
  height: 400px;
  background: url("../assets/img/brand-hero.svg") 0 0 no-repeat;
  background-size: 100% 100%;
  transition: all ease 0.6s;
}
.ellipse {
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
  -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
  -webkit-line-clamp: 2; /** 显示的行数 **/
  overflow: hidden; /** 隐藏超出的内容 **/
}
#contactUs .contactUs-container {
  padding-top: 100px;
  padding-top: 30px;
  text-align: left;
}
#contactUs .contactUs-container button {
  width: 300px;
  height: 50px;
  margin-top: 40px;
  text-align: center;
}
#contactUs .contactUs-container .contactUs-contactWay span {
  display: inline-block;
  width: 48px;
  height: 48px;
  margin: 30px;
}
#contactUs .contactUs-container .contactUs-contactWay span:nth-of-type(1) {
  background: url("../assets/img/weixin.png") 0 0 no-repeat;
  background-size: 100% 100%;
}
#contactUs .contactUs-container .contactUs-contactWay span:nth-of-type(2) {
  background: url("../assets/img/weibo.png") 0 0 no-repeat;
  background-size: 100% 100%;
}
#contactUs .contactUs-container .contactUs-contactWay span:nth-of-type(3) {
  background: url("../assets/img/twitter.png") 0 0 no-repeat;
  background-size: 100% 100%;
}

/* 客户评价 */
#customer {
  padding: 50px 0;
  box-sizing: border-box;
  background: #efefef;
  transition: all ease 0.6s;
}
#customer .customer-title {
  font-size: 30px;
  color: rgb(102, 102, 102);
  margin: 0 0 30px;
}
#customer .customer-block {
  background: #fff;
  padding: 30px;
}
#customer .customer-logo img {
  width: 96px;
  height: 134px;
  border: 1px solid #ccc;
}
#customer .customer-yh img {
  width: 34px;
  height: 34px;
}
#customer .customer-content1 {
  padding-bottom: 20px;
  border-bottom: 1px solid #0ce9f1;
}
#customer .customer-content2 {
  padding-top: 20px;
}

/* 软著 */
#customer1 {
  padding: 50px 0;
  box-sizing: border-box;
  background: #efefef;
  transition: all ease 0.6s;
}
#customer1 .customer-title {
  font-size: 30px;
  color: rgb(102, 102, 102);
  margin: 0 0 30px;
}
#customer1 .customer-block {
  background: #fff;
  padding: 30px;
}
#customer1 .customer-logo img {
  width: 96px;
  height: 134px;
  border: 1px solid #ccc;
}
#customer1 .customer-yh img {
  width: 34px;
  height: 34px;
}
#customer1 .customer-content1 {
  padding-bottom: 20px;
  border-bottom: 1px solid #0ce9f1;
}
#customer1 .customer-content2 {
  padding-top: 20px;
}
/* 为什么选择我们 */
#whyChooseUs {
  padding: 50px 0;
}
#whyChooseUs .whyChooseUs-title {
  margin-bottom: 50px;
  color: rgb(102, 102, 102);
}
#whyChooseUs .whyChooseUs-title p:nth-of-type(1) {
  font-size: 30px;
  font-weight: 500;
}
#whyChooseUs .whyChooseUs-title p:nth-of-type(2) {
  font-size: 14px;
}
#whyChooseUs .server-block {
  padding: 50px 20px;
  border: 1px solid #ccc;
  border-bottom: 5px solid #ccc;
}
#whyChooseUs .server-block img {
  width: 48px;
  height: 48px;
}
#whyChooseUs .server-block > p {
  font-size: 20px;
  margin: 30px 0;
}
#whyChooseUs .server-block > div {
  color: #ccc;
}
.sm-font {
  font-size: 20px;
}
.md-font {
  font-size: 26px !important;
}
/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  .md-font {
    font-size: 22px !important;
  }
  .sm-font {
    font-size: 16px !important;
  }
  #contactUs .contactUs-container button {
    width: 300px;
    height: 50px;
    margin-top: 0px;
    text-align: center;
  }
  #swiper .banner-swiper .swiper-slide-title > h1 {
    font-size: 20px;
    margin-top: 12%;
  }
  #swiper .banner-swiper .swiper-slide-title > p {
    font-size: 14px;
    margin-top: 8%;
    font-weight: 700;
    line-height: 1.5;
  }
  #swiper {
    height: 200px;
  }
  #bigData {
    padding: 30px;
  }
  #bigData .bigData-title {
    font-size: 20px;
  }
  #bigData .bigData-device {
    font-size: 20px;
    margin: 10px 0 10px;
  }
  #contactUs {
    height: 200px;
    transition: all ease 0.6s;
  }
  #contactUs .contactUs-container {
    padding-top: 0;
  }
  #contactUs .contactUs-container h1 {
    font-size: 20px;
  }
  #contactUs .contactUs-container h3 {
    font-size: 16px;
  }
  #contactUs .contactUs-container button {
    width: 200px;
    height: 30px;
    margin-top: 20px;
  }
  #contactUs .contactUs-container .contactUs-contactWay span {
    display: inline-block;
    width: 28px;
    height: 28px;
    margin: 10px;
  }
  #customer {
    padding: 30px 0;
    box-sizing: border-box;
    background: #fff;
  }
  #customer .customer-title {
    font-size: 16px;
    font-weight: bold;
  }
  #customer .customer-logo img {
    width: 96px;
    height: 134px;
  }
  #customer .customer-block {
    padding: 30px;
  }
  #customer .customer-block > div {
    padding: 30px 0;
  }
  #whyChooseUs {
    padding: 20px 0;
    transition: all ease 0.6s;
  }
  #whyChooseUs .whyChooseUs-title p:nth-of-type(1) {
    font-size: 16px;
    font-weight: 700;
  }
  #whyChooseUs .whyChooseUs-title p:nth-of-type(2) {
    font-size: 12px;
  }
  #whyChooseUs .server-block {
    padding: 50px 0;
    border: 1px solid #ccc;
    border-bottom: 5px solid #ccc;
  }
  #whyChooseUs .server-block img {
    width: 48px;
    height: 48px;
  }
  #whyChooseUs .server-block > p {
    font-size: 20px;
    margin: 30px 0;
  }
  #whyChooseUs .server-block > div {
    color: #ccc;
  }
  .ellipse-sm {
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
    -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
    -webkit-line-clamp: 2; /** 显示的行数 **/
    overflow: hidden; /** 隐藏超出的内容 **/
  }
  .sm-top {
    margin-top: 10px;
  }
  .sm-btn-top {
    margin-top: 0 !important;
  }
  .sm-btn-top:hover {
    background: #191a1c;
    color: #fff;
  }
}

/* 媒体查询（平板） */
@media screen and (min-width: 768px) and (max-width: 996px) {
  #swiper .banner-swiper .swiper-slide-title > h1 {
    font-size: 20px;
    margin-top: 12%;
  }
  #swiper .banner-swiper .swiper-slide-title > p {
    font-size: 14px;
    margin-top: 1%;
    font-weight: 700;
  }
  #swiper {
    height: 400px;
  }
  #bigData {
    padding: 60px;
  }
  #bigData .bigData-title {
    font-size: 30px;
  }
  #bigData .bigData-device {
    font-size: 30px;
    margin: 30px 0 15px;
  }
  #contactUs {
    height: 300px;
  }
  #contactUs .contactUs-container {
    padding-top: 50px;
  }
  #contactUs .contactUs-container h1 {
    font-size: 30px;
  }
  #contactUs .contactUs-container h3 {
    font-size: 20px;
  }
  #contactUs .contactUs-container button {
    width: 300px;
    height: 50px;
    margin-top: 30px;
  }
  #contactUs .contactUs-container .contactUs-contactWay span {
    display: inline-block;
    width: 32px;
    height: 32px;
    margin: 15px;
  }
  #whyChooseUs .whyChooseUs-title p:nth-of-type(1) {
    font-size: 24px;
    font-weight: 700;
  }
  #customer .customer-title {
    font-size: 24px;
  }
  #whyChooseUs {
    padding: 20px 0;
  }
}

/**解决方案  陈鹏新增20250723*/
.team-member.div_solution {
  margin-bottom: 0;
  transition: box-shadow 0.3s, border-color 0.3s;
  border: 2px solid #e6e8ed;
  border-radius: 0;
  box-shadow: 0 2px 10px rgba(20, 40, 80, 0.03);
  background: #fff;
  position: relative;
  z-index: 1;
  padding: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.industry-card {
  box-sizing: border-box;
}

.team-member.div_solution:hover {
  border-color: #e53935;
  box-shadow: 0 6px 24px rgba(229, 57, 53, 0.15), 0 1.5px 8px rgba(229, 57, 53, 0.08);
  z-index: 2;
  transition: box-shadow 0.3s, border-color 0.3s;
}

.team-member.div_solution .image {
  overflow: hidden;
  border-radius: 0;
  margin: 0;
  padding: 0;
}

.team-member.div_solution .solution-img {
  width: 100%;
  max-width: 100%;
  height: 160px;
  object-fit: cover;
  border-radius: 0;
  display: block;
  margin: 0;
  padding: 0;
}

.team-member-box {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background: #fff;
  padding: 20px 16px 25px 16px;
}

/* 小屏下换行 */
@media (max-width: 1200px) {
  .d-flex.justify-content-center {
    gap: 16px !important;
  }
  .team-member.div_solution {
    font-size: 15px;
  }
  .team-member.div_solution.industry-card {
    flex: 0 0 45vw !important;
    max-width: 45vw !important;
  }
}

@media (max-width: 991px) {
  .d-flex.justify-content-center {
    flex-wrap: wrap !important;
    gap: 16px !important;
  }
  .team-member.div_solution.industry-card {
    flex: 0 0 90vw !important;
    max-width: 90vw !important;
    margin-bottom: 16px;
  }
}

@media (max-width: 767px) {
  .d-flex.justify-content-center {
    flex-direction: column !important;
    gap: 12px !important;
  }
  .team-member.div_solution.industry-card {
    flex: 1 0 100% !important;
    max-width: 100% !important;
    margin-bottom: 12px;
  }
}

.solutions_hangye_title {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  text-align: center;
  margin-bottom: 10px;
}

.solutions_hangye_title span {
  display: block;
  width: 100%;
}

/**公司优势  陈鹏新增20250723*/
#Service {
  padding: 50px 0;
  box-sizing: border-box;
  background: url("~@/assets/img/brand-hero.svg") no-repeat center center;
  transition: all ease 0.6s;
}
#Service .Service-title {
  font-size: 30px;
  color: rgb(102, 102, 102);
  margin: 0 0 30px;
}
#Service .Service-title2 {
  font-size: 25px;
  color: rgb(226, 220, 220);
  margin: 30px 0 30px 0;
  padding-bottom: 20px;
}
#Service .Service-block {
  background: #fff;
  padding: 30px;
}
#Service .Service-logo img {
  width: 96px;
  height: 134px;
  border: 1px solid #ccc;
}
#Service .Service-yh img {
  width: 34px;
  height: 34px;
}
#Service .Service-content1 {
  padding-bottom: 20px;
  border-bottom: 1px solid #0ce9f1;
}
#Service .Service-content2 {
  padding-top: 20px;
}

Service-container {
  padding: 0px 50px;
}
.Service-item-wrapper {
  cursor: pointer;
  background: rgba(244, 244, 244, 1);
  overflow: hidden;
  position: relative;
}
.Service-item-top {
  width: 100%;
  height: 120px;
  padding: 30px;
  text-align: center;
}
.Service-item-top > i {
  display: inline-block;
  width: 25px;
  height: 2px;
  background: #28f;
}
.Service-item-top > p {
  font-size: 0.8rem;
  color: #b2b2b2;
  opacity: 0;
  transform: translateY(10px);
  /* transform: translateY(-10px); */
  transition: all 0.5s ease;
}
.Service-item-img {
  width: 100%;
  overflow: hidden;
}
.Service-item-img img {
  width: 100%;
  transition: all 0.5s ease;
}
.Service-item-border {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  z-index: 9999;
  width: 100%;
  height: 100%;
  transition: all 0.5s ease;
  border: 1px solid #000;
  opacity: 0;
}
.Service-item-wrapper:hover .Service-item-top > i {
  opacity: 0;
}
.Service-item-wrapper:hover .Service-item-top > p {
  opacity: 1;
  transform: translateY(-10px);
}
.Service-item-wrapper:hover .Service-item-img > img {
  transform: scale(1.1, 1.1);
}
.Service-item-wrapper:hover > .Service-item-border {
  opacity: 1;
  width: 90%;
  height: 90%;
}

.active {
  position: relative;
}

.active::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 50px;
  height: 3px;
  background-color: #409eff; /* 选中下划线颜色 */
  border-radius: 3px;
}

/* 只保留卡片外观，不设置宽度和margin */
/* 圆形头像 */
.card {
  width: 110px;
  height: 110px;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(-50%, -40%);
  z-index: 2;
}

.card-img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.card-content {
  width: 100%;
  padding-top: 5px; /* 必须与.advantage-card的padding-top配合，避免被圆形遮住 */
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1 auto;
  padding-left: 5px;
  padding-right: 5px;
}

.card-text {
  font-size: 17px;
  color: #333;
  margin-bottom: 10px;
  font-weight: 600;
}

.card-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
}

/* 外层flex容器，4列自适应 */
.advantage-card-container {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: center;
}

/* 每行4个，响应式自适应 */
.advantage-card {
  position: relative;
  flex: 1 1 calc(25% - 16px);
  min-width: 200px;
  max-width: 300px;
  margin: 8px 0;
  background-color: #e6f2ff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 70px; /* 为圆形头像留空间 */
  box-sizing: border-box;
  overflow: visible;
}

/* 小屏改为2列或1列 */
@media (max-width: 991px) {
  .advantage-card {
    flex: 1 1 calc(50% - 16px);
    max-width: 100%;
  }
}
@media (max-width: 600px) {
  .advantage-card {
    flex: 1 1 100%;
    max-width: 100%;
  }
}

.card-img {
  width: 80px; /* 缩小图片 */
  height: 80px;
  object-fit: cover;
  display: block;
  margin: 0 auto 16px auto;
}

.card-text {
  font-size: 16px;
  color: #333;
  text-align: center; /* 再次保证文字居中 */
}

/**新闻中心  陈鹏新增20250723*/
.default-blog-news .img-box img {
  width: 100%;
  height: 280px;
  object-fit: cover;
  display: block;
}

/* 荣誉资质证书卡（CertReplica）尺寸自适应：与 /newsinformation 页口径一致，
   证书封顶 300px 并居中，不再随卡片/大屏无限放大。
   ⚠️ 限宽必须加在父容器：.cert-replica 靠 padding-bottom:125% 撑 4:5 比例，
      百分比 padding 按父容器宽度计算，直接给 .cert-replica 加 max-width 会让宽高比失真。 */
.default-blog-news .img-box {
  max-width: 300px;
  margin-left: auto;
  margin-right: auto;
  overflow: hidden;
}

/* 手机竖向（≤575px）证书改 2 列网格：原单列 + max-width:300px 时证书约 300px ≈ 屏宽 77%，
   显得"太大"。改 50% 后与 /newsinformation 页口径一致（cert 缩到 ~半宽）。
   ⚠️ .col-xs-12 在本页不止证书卡用（新闻列表/合作伙伴等也用），不能直接写 .col-xs-12{width:50%}，
   否则会误伤其它区块 → 用荣誉资质区块父级 #whyChooseUs 限定，只命中其内部的 4 张证书卡。 */
@media screen and (max-width: 575px) {
  #whyChooseUs .col-xs-12 {
    width: 50%;
  }
}

.home_news_a {
  display: inline-block;
  color: #222;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
  transition: color 0.2s;
  line-height: 1.8;
  cursor: pointer;
}

.home_news_a:hover {
  color: #1366e6;
  text-decoration: underline;
}
@media (max-width: 768px) {
  .home_news_a {
    font-size: 15px;
  }
}

/* 合作伙伴：HTML 卡片网格（参考 daohuasoft：白底 logo 区 + 名称条） */
.partner-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 24px 20px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

.partner-box {
  background: #ffffff;
  border: 1px solid #f0f0f0;
  border-radius: 2px;
  overflow: hidden;
  /* 纵向弹性：logo 区固定、名称区自适应，保证同行卡片等高 */
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
}

.partner-box:hover {
  transform: translateY(-4px);
  border-color: rgba(230, 0, 76, 0.25);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06), 0 8px 24px rgba(0, 0, 0, 0.08);
}

.partner-box-logo {
  height: 118px;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px 16px;
  background: #ffffff;
}

.partner-box-logo img {
  max-width: 82%;
  max-height: 74px;
  object-fit: contain;
  /* 官方 logo 保持真实色彩（原为 grayscale(25%)），避免第三方标识失真 */
  transition: opacity 0.3s ease;
}

.partner-box-placeholder {
  display: inline-flex;
  color: #e6004c;
  opacity: 0.5;
}

.partner-box-name {
  flex: 1 1 auto;
  min-height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 10px;
  color: #444444;
  font-size: 14px;
  line-height: 1.4;
  text-align: center;
  border-top: 1px solid #f2f2f2;
  transition: color 0.3s ease;
}

.partner-box:hover .partner-box-name {
  color: #e6004c;
}

.partner-note {
  text-align: center;
  color: #676767;
  font-size: 12px;
  margin: 24px 0 0;
}

@media (max-width: 767px) {
  .partner-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px 12px;
  }
  .partner-box-logo {
    height: 92px;
  }
  .partner-box-name {
    font-size: 13px;
  }
}

@import url("../assets/css/bootstrap.min.css");

/* 行业四卡：政策-技术-产品-成效 四线结构 */
.ind-summary {
  margin: 14px 0 0;
  font-size: 13px;
  line-height: 1.8;
  color: #5a6270;
  text-align: center;
}
@media (max-width: 575px) {
  .ind-summary {
    font-size: 13.5px;
  }
}

/* 解决方案板块（C 方案：浅灰底 + 双色标题） */
.about1-section {
  background: #f7f8fa;
}
.about1-section .about-images {
  width: 100%;
  max-width: 560px;
}
</style>



// WEBPACK FOOTER //
// src/view/HomePage2.vue